import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

export const Plus = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M8.72271 7.04074L13.7827 7.04074L13.7827 8.48615L8.72271 8.48615V13.5461H7.27729V8.48615L2.21732 8.48615L2.21732 7.04074L7.27729 7.04074L7.27729 1.98077H8.72271L8.72271 7.04074Z"
      fill="currentColor"
    />
  </svg>
);
